import { render } from "./SidebarHeader.vue?vue&type=template&id=b39f9f20&ts=true"
import script from "./SidebarHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./SidebarHeader.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/sidebar/SidebarHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b39f9f20"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b39f9f20', __exports__)) {
    api.reload('b39f9f20', __exports__)
  }
  
  module.hot.accept("./SidebarHeader.vue?vue&type=template&id=b39f9f20&ts=true", () => {
    api.rerender('b39f9f20', render)
  })

}


export default __exports__